import dashboardIcon from "../../../assets/icons/submenu/dashboard.png";
import contentIcon from "../../../assets/icons/submenu/content.png";
import designIcon from "../../../assets/icons/submenu/design.png";
import graduationIcon from "../../../assets/icons/submenu/graduation.png";
import pushNotificationIcon from "../../../assets/icons/submenu/push-notification.png";
import goGoLiveIcon from "../../../assets/icons/submenu/go-go-live.png";
import importantNoticeIcon from "../../../assets/icons/submenu/important-notice.png";
import faceCallIcon from "../../../assets/icons/submenu/face-call.png";
import versionIcon from "../../../assets/icons/submenu/version.png";
import leadsManagementIcon from "../../../assets/icons/submenu/leads-management.png";
import vesIcon from "../../../assets/icons/submenu/ves.png";
import videoIcon from "../../../assets/icons/submenu/video.png";
import warrantyIcon from "../../../assets/icons/submenu/warranty.png";
import calendarIcon from "../../../assets/icons/submenu/calendar.png";
import {
  ServiceCategoryRouteTypes,
  ServiceCategoryTypes,
  ServiceRouteTypes,
  ServiceTypes,
} from "../../../types/types";
import { ServiceItemsType } from "./types";

export const subMenuWidth = 220;

export const serviceItems: ServiceItemsType[] = [
  {
    service: ServiceTypes.CLUB_APP,
    serviceRoute: ServiceRouteTypes.CLUB_APP,
    title: "WF Club App",
    items: [
      {
        category: ServiceCategoryTypes.DASHBOARD,
        categoryRoute: ServiceCategoryRouteTypes.DASHBOARD,
        icon: dashboardIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.DESIGN,
        categoryRoute: ServiceCategoryRouteTypes.DESIGN,
        icon: designIcon,
        subItems: [
          {
            subItemName: "Announcement Bar",
            routeName: "announcement-bar",
          },
          {
            subItemName: "Service Icon",
            routeName: "service-banner-and-icon",
          },
          {
            subItemName: "Event Banner",
            routeName: "event-banner",
          },
        ],
      },
      {
        category: ServiceCategoryTypes.CLUB_APP_PUSH_NOTIFICATION,
        categoryRoute: ServiceCategoryRouteTypes.CLUB_APP_PUSH_NOTIFICATION,
        icon: pushNotificationIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.CLUB_APP_FACE_CALL,
        categoryRoute: ServiceCategoryRouteTypes.CLUB_APP_FACE_CALL,
        icon: faceCallIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.VIDEOS,
        categoryRoute: ServiceCategoryRouteTypes.VIDEO_MANAGEMENT,
        icon: videoIcon,
        subItems: [{ subItemName: "Kid's World", routeName: "kids-world" }],
      },
      {
        category: ServiceCategoryTypes.WARRANTY,
        categoryRoute: ServiceCategoryRouteTypes.WARRANTY,
        icon: warrantyIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.GRADUATION,
        categoryRoute: ServiceCategoryRouteTypes.GRADUATION,
        icon: graduationIcon,
        subItems: [
          {
            subItemName: "Waiting for Review",
            routeName: "waiting-for-review",
          },
          {
            subItemName: "All Applications",
            routeName: "all-applications",
          },
          {
            subItemName: "Kids Info",
            routeName: "kids-info",
          },
        ],
      },
      {
        category: ServiceCategoryTypes.CLUB_APP_GO_GO_LIVE,
        categoryRoute: ServiceCategoryRouteTypes.CLUB_APP_GO_GO_LIVE,
        icon: vesIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.CLUB_APP_IMPORTANT_NOTICE,
        categoryRoute: ServiceCategoryRouteTypes.CLUB_APP_IMPORTANT_NOTICE,
        icon: importantNoticeIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.CLUB_APP_RELEASE_VERSION,
        categoryRoute: ServiceCategoryRouteTypes.CLUB_APP_RELEASE_VERSION,
        icon: versionIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.CLUB_APP_BUY_UP_QUERY,
        categoryRoute: ServiceCategoryRouteTypes.CLUB_APP_BUY_UP_QUERY,
        icon: dashboardIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.POWER_BI_TEST,
        categoryRoute: ServiceCategoryRouteTypes.POWER_BI_TEST,
        icon: dashboardIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.ENTRY_PACKAGE_QUERY,
        categoryRoute: ServiceCategoryRouteTypes.ENTRY_PACKAGE_QUERY,
        icon: dashboardIcon,
        subItems: [],
      },
    ],
  },
  {
    service: ServiceTypes.CHECK_IN,
    serviceRoute: ServiceRouteTypes.CHECK_IN,
    title: "Check-in App",
    items: [
      {
        category: ServiceCategoryTypes.DASHBOARD,
        categoryRoute: ServiceCategoryRouteTypes.DASHBOARD,
        icon: dashboardIcon,
        subItems: [],
      },
    ],
  },
  {
    service: ServiceTypes.CLUB_SERVICE,
    serviceRoute: ServiceRouteTypes.CLUB_SERVICE,
    title: "Club Service",
    items: [
      {
        category: ServiceCategoryTypes.DASHBOARD,
        categoryRoute: ServiceCategoryRouteTypes.DASHBOARD,
        icon: dashboardIcon,
        subItems: [],
      },
    ],
  },
  {
    service: ServiceTypes.SALES_188,
    serviceRoute: ServiceRouteTypes.SALES_188,
    title: "Sales 188 App",
    items: [
      {
        category: ServiceCategoryTypes.DASHBOARD,
        categoryRoute: ServiceCategoryRouteTypes.DASHBOARD,
        icon: dashboardIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.SALES_188_PUSH_NOTIFICATION,
        categoryRoute: ServiceCategoryRouteTypes.SALES_188_PUSH_NOTIFICATION,
        icon: pushNotificationIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.SALES_188_RELEASE_VERSION,
        categoryRoute: ServiceCategoryRouteTypes.SALES_188_RELEASE_VERSION,
        icon: versionIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.SALES_188_TAIWAN_SALES,
        categoryRoute: ServiceCategoryRouteTypes.SALES_188_TAIWAN_SALES,
        icon: dashboardIcon,
        subItems: [
          {
            subItemName: "Sales info",
            routeName: "member-info",
          },
          {
            subItemName: "Sales Contest Report",
            routeName: "sales-contest-report",
          },
        ],
      },
      {
        category: ServiceCategoryTypes.SALES_188_BUSINESS_MANAGEMENT,
        categoryRoute: ServiceCategoryRouteTypes.SALES_188_BUSINESS_MANAGEMENT,
        icon: leadsManagementIcon,
        subItems: [
          {
            subItemName: "공지사항",
            routeName: "announcement-list",
          },
          // {
          //   subItemName: "자료실",
          //   routeName: "",
          // },
          {
            subItemName: "월간 일정",
            routeName: "calendar",
          },
          {
            subItemName: "1:1 게시판",
            routeName: "one-on-one-board",
          },
          {
            subItemName: "메세지함",
            routeName: "message-box",
          },
          // {
          //   subItemName: "My Classroom",
          //   routeName: "",
          // },
          // {
          //   subItemName: "그룹로컬마케팅",
          //   routeName: "",
          // },
        ],
      },
      {
        category: ServiceCategoryTypes.SALES_188_LEAD_MANAGEMENT,
        categoryRoute: ServiceCategoryRouteTypes.SALES_188_LEAD_MANAGEMENT,
        icon: leadsManagementIcon,
        subItems: [
          // {
          //   subItemName: "리드 자동배분 현황",
          //   routeName: "",
          // },
          {
            subItemName: "리드조회 및 관리",
            routeName: "lead-inquiry",
          },
          {
            subItemName: "신규리드 등록",
            routeName: "lead-registration",
          },
          {
            subItemName: "DL Upload",
            routeName: "dl-upload",
          },
          // {
          //   subItemName: "중복리드 조회 현황",
          //   routeName: "",
          // },
        ],
      },
      {
        category: ServiceCategoryTypes.SALES_188_SYSTEM_MANAGEMENT,
        categoryRoute: ServiceCategoryRouteTypes.SALES_188_SYSTEM_MANAGEMENT,
        icon: leadsManagementIcon,
        subItems: [
          {
            subItemName: "어드바이저 관리",
            routeName: "advisor-management",
          },
          // {
          //   subItemName: "지사정보 관리",
          //   routeName: "",
          // },
          {
            subItemName: "담당지역 관리",
            routeName: "advisor-region",
          },
          // {
          //   subItemName: "등급 관리",
          //   routeName: "",
          // },
          // {
          //   subItemName: "분류 관리",
          //   routeName: "",
          // },
          {
            subItemName: "분류 관리 - 미디어코드",
            routeName: "media-code",
          },
          // {
          //   subItemName: "메뉴권한 관리",
          //   routeName: "",
          // },
        ],
      },
    ],
  },
  {
    service: ServiceTypes.DEMO,
    serviceRoute: ServiceRouteTypes.DEMO,
    title: "WFE demo",
    items: [
      {
        category: ServiceCategoryTypes.DASHBOARD,
        categoryRoute: ServiceCategoryRouteTypes.DASHBOARD,
        icon: dashboardIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.VIDEO_MANAGEMENT,
        categoryRoute: ServiceCategoryRouteTypes.VIDEO_MANAGEMENT,
        icon: contentIcon,
        subItems: [
          {
            subItemName: "Testimonial",
            routeName: "testimonial",
          },
          {
            subItemName: "Club services",
            routeName: "club-services",
          },
          {
            subItemName: "Company & news",
            routeName: "company-news",
          },
        ],
      },
    ],
  },
  {
    service: ServiceTypes.TRIAL_MODE,
    serviceRoute: ServiceRouteTypes.TRIAL_MODE,
    title: "Trial Mode",
    items: [
      {
        category: ServiceCategoryTypes.DATA_ANALYSIS,
        categoryRoute: ServiceCategoryRouteTypes.DATA_ANALYSIS,
        icon: dashboardIcon,
        subItems: [
          { subItemName: "Dashboard", routeName: "dashboard" },
          {
            subItemName: "Leads Detail Download",
            routeName: "leads-detail-download",
          },
          { subItemName: "Campaign ID", routeName: "campaign-id" },
        ],
      },
      {
        category: ServiceCategoryTypes.CONTENT,
        categoryRoute: ServiceCategoryRouteTypes.CONTENT,
        icon: contentIcon,
        subItems: [
          {
            subItemName: "Trial Announcement Bar",
            routeName: "trial-announcement-bar",
          },
          {
            subItemName: "Local Event",
            routeName: "local-event",
          },
          {
            subItemName: "Testimonial",
            routeName: "trial-testimonial",
          },
          {
            subItemName: "Caring CTA",
            routeName: "caring-cta",
          },
          {
            subItemName: "Journey Card",
            routeName: "journey-card",
          },
          {
            subItemName: "Trial Content",
            routeName: "trial-content",
          },
          {
            subItemName: "Trial Content Upload",
            routeName: "trial-content-upload",
          },
        ],
      },
      {
        category: ServiceCategoryTypes.TRIAL_MODE_PUSH_NOTIFICATION,
        categoryRoute: ServiceCategoryRouteTypes.TRIAL_MODE_PUSH_NOTIFICATION,
        icon: pushNotificationIcon,
        subItems: [],
      },
    ],
  },
  {
    service: ServiceTypes.MKT,
    serviceRoute: ServiceRouteTypes.MKT,
    title: "Marketing Service",
    items: [
      {
        category: ServiceCategoryTypes.DASHBOARD,
        categoryRoute: ServiceCategoryRouteTypes.DASHBOARD,
        icon: dashboardIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.CONTENT,
        categoryRoute: ServiceCategoryRouteTypes.CONTENT,
        icon: dashboardIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.REPORT,
        categoryRoute: ServiceCategoryRouteTypes.REPORT,
        icon: contentIcon,
        subItems: [
          {
            subItemName: "Vendor Reports",
            routeName: "vendor-reports",
          },
          {
            subItemName: "Ad Exclusion List",
            routeName: "ad-exclusion-list",
          },
          {
            subItemName: "Get Winner",
            routeName: "get-winner",
          },
          {
            subItemName: "EALM激勵獎金報表",
            routeName: "ealm-bonus",
          },
          {
            subItemName: "EALM積點奬勵",
            routeName: "ealm-bonus-incentive",
          },
          {
            subItemName: "EALM活動廠商開發成效表",
            routeName: "ealm-vendor-performance",
          },
          {
            subItemName: "匯入Internet Cost",
            routeName: "internet-source-cost",
          },
        ],
      },
      {
        category: ServiceCategoryTypes.LEADS_MANAGEMENT,
        categoryRoute: ServiceCategoryRouteTypes.LEADS_MANAGEMENT,
        icon: contentIcon,
        subItems: [
          {
            subItemName: "Merge Leads",
            routeName: "merge-leads",
          },
          {
            subItemName: "Update Source Code",
            routeName: "update-source-code",
          },
          {
            subItemName: "Internet Leads 轉檔",
            routeName: "internet-leads-conversion",
          },
        ],
      },
    ],
  },
  {
    service: ServiceTypes.TECHPRESSO,
    serviceRoute: ServiceRouteTypes.TECHPRESSO,
    title: "Techpresso App",
    items: [
      {
        category: ServiceCategoryTypes.DASHBOARD,
        categoryRoute: ServiceCategoryRouteTypes.DASHBOARD,
        icon: dashboardIcon,
        subItems: [],
      },
    ],
  },
  {
    service: ServiceTypes.ZIPPY_AND_ME,
    serviceRoute: ServiceRouteTypes.ZIPPY_AND_ME,
    serviceMenuTitle: "Zippy Digital",
    title: "Zippy And Me",
    items: [
      {
        category: ServiceCategoryTypes.DASHBOARD,
        categoryRoute: ServiceCategoryRouteTypes.DASHBOARD,
        icon: dashboardIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.ZIPPY_AND_ME_STORY_TIME,
        categoryRoute: ServiceCategoryRouteTypes.ZIPPY_AND_ME_STORY_TIME,
        icon: contentIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.ZIPPY_AND_ME_DAILY_CHECKIN,
        categoryRoute: ServiceCategoryRouteTypes.ZIPPY_AND_ME_DAILY_CHECKIN,
        icon: calendarIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.ZIPPY_AND_ME_CHANNEL,
        categoryRoute: ServiceCategoryRouteTypes.ZIPPY_AND_ME_CHANNEL,
        icon: videoIcon,
        subItems: [],
      },
      {
        category: ServiceCategoryTypes.ZIPPY_AND_ME_FACE_CALL,
        categoryRoute: ServiceCategoryRouteTypes.ZIPPY_AND_ME_FACE_CALL,
        icon: faceCallIcon,
        subItems: [],
      },
    ],
  },
];
